import { createSelector } from "@reduxjs/toolkit";
import { SET_USER_IMAGES, SET_USER_NAME } from "../actions/userProfileActions";

export const getUserProfile = createSelector(
    state => state.userProfileState,
    userProfileState => {
        return {
            name: userProfileState.name,
            images: userProfileState.images,
            empty: userProfileState.name === ""
        }
    }
);

export const getUserName = createSelector(
    state => state.userProfileState,
    userProfileState => userProfileState.name
);

export const getUserImages = createSelector(
    state => state.userProfileState,
    userProfileState => userProfileState.images
);

const INITIAL_STATE = {
    name: "",
    images: {}
}

export const userProfileState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_USER_NAME:
            return {...state, name: action.payload};
        case SET_USER_IMAGES:
            return {...state, images: action.payload};
        default:
            return state;
    }
}